export default __webpack_public_path__ + "static/media/frutiger-55roman.02343fb5.svg";